import React, { useEffect } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import EducatorStudentToggle from './EducatorStudentToggle';
import HomeGreeting from './HomeGreeting';
import HomeSpacesSection from './HomeSpacesSection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Home - Aula';
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="1.5rem"
      padding="1.5rem 2rem 2rem"
      height="100%"
      sx={{ overflowY: 'auto' }}
    >
      <HomeGreeting />
      <EducatorStudentToggle />
      <HomeSpacesSection />
    </Box>
  );
};

export default HomePage;
